import React, { Fragment, useEffect, useState } from 'react'
import { Form, Input, InputNumber, Button, Cascader, Select, Radio, Table, Popconfirm, Card, Row, Col, Switch, message } from "antd"
import { HTTP_SUCCESS_CODE, PRODUCT_TYPE, ONLINE_TYPE, SERVICE_TYPE, CLINIC_KEY } from "@/utils/consts"
import { queryCategory } from '@/services/commodity'
// import { checkProductCodeExist, generateProductCode, getServiceList } from '@/services/pms'
import { cloneDeep } from "lodash"
import ProductModal from '../../../order/components/ProductModal'
import ProductDetail from '../../../order/components/ProductDetail'
import { arrayToTree } from '@/utils/utils'
import { Decimal } from 'decimal.js'

const FormItem = Form.Item
const { Option } = Select
const { TextArea } = Input

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 },
    md: { span: 18 },
  },
}

const formItemLayout2 = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 2 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 20 },
    md: { span: 20 },
  },
}


const submitFormLayout = {
  wrapperCol: {
    xs: { span: 24, offset: 0 },
    sm: { span: 10, offset: 11 },
  },
}

const QUANTITY_MAX = 1000

function calOrderItemSum(price, num, discount) {
  if (isNaN(price) || isNaN(num) || isNaN(discount)) return 0

  return new Decimal(price).mul(num).mul(discount).div(100).toFixed(2)
}

/**
 * 获取商品列表item数据
 */
function getProductItemData(item) {
  return {
    name: item.name,
    productId: item.id,
    quantity: item.number
  }
}

/**
 * 获取模板商品列表item数据
 */
function getComboProductItemData(item) {
  return {
    name: item.name,
    categories: item.categoryList,
    number: item.quantity,
    ...item.product
  }
}

const ProductInfo = ({
  categorys,
  onOk,
  visible,
  data,
  service,
  clinicId,
  form: {
    getFieldDecorator,
    validateFields,
    getFieldsValue,
    getFieldValue,
    setFieldsValue,
    resetFields
  }
}) => {
  const [productVisible, setProductVisible] = useState(false)
  const [categories, setCategories] = useState([])
  const [dataSource, setDataSource] = useState([])
  const [productDetailVisible, setProductDetailVisible] = useState(false)
  const [productInfo, setProductInfo] = useState({})

  useEffect(() => {
    fetchClinicProductCategory(clinicId)
    if (data.orderTemplateVos) {
      let newDates = data.orderTemplateVos[0].orderItemTemplateVos.map(_ => getComboProductItemData(_))
      setDataSource([...newDates])
    }
  }, [data])
  const column = [
    {
      title: '商品编码',
      dataIndex: 'code',
      width: '14%',
      editable: true,
      ellipsis: true,
    },
    {
      title: '商品分类',
      dataIndex: 'categories',
      width: '15%',
      editable: true,
      render: text => (text || []).map(_ => _.name).join('/')
    },
    {
      title: '商品名称',
      dataIndex: 'name',
      // width: '45%',
      editable: true,
    },
    {
      title: '商品数量',
      dataIndex: 'number',
      width: '10%',
      align: 'center',
      editable: true,
      render(text, record, index) {
        return (
          <InputNumber
            min={1}
            max={QUANTITY_MAX}
            precision={0}
            value={text}
            onChange={(e) => handleOrderChange('number', e, index)}
            style={{ width: 60 }}
          />
        )
      }
    },
    {
      title: '商品频次',
      dataIndex: 'quantity',
      width: '8%',
      editable: true,
    },
    {
      title: '商品价格',
      dataIndex: 'price',
      width: '12%',
      editable: true,
    },
    {
      title: '操作',
      width: '10%',
      dataIndex: 'operation',
      render: (text, record) => {
        return <span>
          <a style={{ marginRight: 8 }} onClick={() => handleOpenDetail(record)}>查看</a>

          <a onClick={() => handleDelete(record)}>删除</a>
        </span>
      },
    },
  ]

  const handleOrderChange = (type, value, index) => {
    const newDataSource = dataSource.map((item, idx) => {
      if (idx !== index) return item
      if (type === 'number' && value > 0) {
        value = String(value).replace(/\.\d+$/, '')
        value = value > QUANTITY_MAX ? value.slice(0, String(QUANTITY_MAX).length) : value
        value = parseInt(value)
      }

      item[type] = value

      return item
    })
    setDataSource(newDataSource)
  }

  // 查看
  const handleOpenDetail = record => {
    setProductDetailVisible(true)
    setProductInfo(record)
  }

  // 删除
  const handleDelete = record => {
    setDataSource(prevState => {
      const newData = prevState.filter(_ => _.id !== record.id)
      return newData
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    validateFields(errors => {
      if (errors) {
        return
      }
      if (dataSource.length === 0) {
        message.error('请完成产品配置')
        return
      }
      let params = getFieldsValue()
      let newOrderTemplateReqs = [{
        category: "service",
        clinicId: clinicId,
        name: params.name,
        newOrderItemTemplateReqs: dataSource.map(_ => getProductItemData(_))
      }]
      let orderTemplateResps = [{
        category: "service",
        clinicId: clinicId,
        name: params.name,
        orderItemTemplateVos: dataSource.map(_ => getProductItemData(_))
      }]
      const datas = {
        ...params,
        type: 'clinic',
        comboId: data.comboId || undefined,
      }
      if (data.comboId) {
        datas.orderTemplateResps = orderTemplateResps
        datas.enable = false
        datas.clinicId = clinicId
      } else {
        datas.newOrderTemplateReqs = newOrderTemplateReqs
      }

      // return console.log('params---', datas)

      onOk(datas)
      resetFields(['name', 'price', 'description'])
      setDataSource([])
    })
  }

  // const handleChange = async (categoryId, productName) => {
  //   if (categoryId && categoryId.length && productName && productName.length > 1) {
  //     let param = {
  //       categoryId: categoryId[categoryId.length - 1],
  //       productName
  //     }
  //     const { code, data } = await generateProductCode({ ...param })
  //     if (code === 0 && data) {
  //       setFieldsValue({ 'code': data })
  //     }
  //   }
  // }

  useEffect(() => {
    let price = dataSource.reduce((prev, current, index) => {
      const { price, number } = current
      if (number && price) {
        prev = prev.add(new Decimal(number).mul(new Decimal(price)))
      }
      return index === dataSource.length - 1 ? prev.toFixed(2) : prev
    }, new Decimal(0))
    setFieldsValue({ price: new Decimal(price).toFixed(6) })
  }, [dataSource])

  // 获取诊所产品类型
  const fetchClinicProductCategory = async () => {
    const res = await queryCategory({ pageNo: 1, pageSize: 100, typeList: ['service_product'] })

    if (!res || res.code !== HTTP_SUCCESS_CODE) return

    const tempData = (res.data.rows || []).map(_ => {
      return {
        title: _.name,
        key: _.id,
        id: _.id,
        value: _.id,
        pid: _.parentId
      }
    })
    const categories = arrayToTree(tempData)
    setCategories(categories)
  }

  const categoryIds = (data.categories || []).map(_ => _.id)

  const productProps = {
    width: 900,
    visible: productVisible,
    title: '选择商品',
    maskClosable: true,
    closable: true,
    wrapClassName: 'vertical-center-modal',
    onOk: (orderItems) => {
      setDataSource(prevState => {
        const filteredItems = prevState.filter(_ => !!_.id)
        return orderItems.reduce((prev, current) => {
          const { categories, id, price } = current
          const index = prev.findIndex(_ => _.id === id)
          if (index > -1) {
            const item = prev[index]
            const number = (item.number || 0) + 1
            item.number = number
          } else {
            prev.push({
              number: 1,
              ...current
            })
          }
          return prev
        }, filteredItems)
      })
      setProductVisible(false)
    },
    onCancel: () => {
      setProductVisible(false)
    },
    onOpenDetail: (record) => {
      setProductDetailVisible(true)
      setProductInfo(record)
    },
    productCategories: categories,
    clinicId
  }

  const productDetailProps = {
    width: 500,
    visible: productDetailVisible,
    title: `商品信息--${productInfo.name}`,
    maskClosable: false,
    footer: false,
    data: productInfo,
    wrapClassName: 'vertical-center-modal',
    onCancel: () => {
      setProductDetailVisible(false)
    }
  }

  return (
    <Form onSubmit={(e) => handleSubmit(e)} style={{ display: visible ? 'block' : 'none', margin: '8px auto' }}>
      <Card title='套餐基本信息' size='small'>
        <Row >
          <Col span={8}>
            <FormItem {...formItemLayout} label="套餐分类" >
              {getFieldDecorator('categoryIds', {
                initialValue: categoryIds,
                rules: [
                  {
                    required: true,
                    message: '必填项',
                  },
                ],
              })(<Cascader
                options={categorys}
                changeOnSelect
              />)}
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem {...formItemLayout} label="套餐名称">
              {getFieldDecorator('name', {
                initialValue: data.name,
                rules: [
                  {
                    required: true,
                    message: '必填项',
                  },
                ],
              })(<Input />)}
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem {...formItemLayout} label="套餐价格">
              {getFieldDecorator('price', {
                initialValue: data.price,
                rules: [
                  {
                    required: true,
                    message: '必填项',
                  },
                ],
              })(<InputNumber min={0} precision={2} />)}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <FormItem {...formItemLayout2} label="套餐描述">
              {getFieldDecorator('description', {
                initialValue: data.description,
              })(<TextArea autoSize={{ minRows: 3, maxRows: 8 }} maxLength={1000} />)}
            </FormItem>
          </Col>
        </Row>
      </Card>
      <Card title='产品配置' size='small' style={{ marginTop: 20 }} extra={<Button type='primary' size='small' onClick={() => setProductVisible(true)}>选择商品</Button>}>
        <Table
          columns={column}
          dataSource={dataSource}
          pagination={false}
          size='small'
        ></Table>
      </Card>
      <FormItem {...submitFormLayout} style={{ marginTop: 32 }}>
        <Button type="primary" icon="arrow-right" htmlType="submit" >
          提交
        </Button>
      </FormItem>
      {productVisible && <ProductModal {...productProps} />}
      {productDetailVisible && <ProductDetail {...productDetailProps} />}
    </Form>

  )
}

export default Form.create()(ProductInfo)
